import React from 'react';
import propTypes from 'prop-types';

import { useGetAmountSummaryFromFulfillment } from '../../../fulfillment-plans/amount-summary/use-get-amount-summary-from-fulfillment';
import CurrencyColumn from '../../../components/columns/currency-column';
import { messages } from '../messages';

const ShippingPaidColumn = ({ fulfillmentId }) => {
  const amountSummary = useGetAmountSummaryFromFulfillment(fulfillmentId);
  if (!amountSummary?.shippingAmount) {
    return '';
  }
  const { value, code } = amountSummary.shippingAmount;

  return <CurrencyColumn currencyCode={code} value={value} />;
};

ShippingPaidColumn.propTypes = {
  fulfillmentId: propTypes.string.isRequired,
};

export const ShippingPaid = {
  getMessageDescriptor: () => messages.shippingPaid,
  id: 'shippingPaid',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <ShippingPaidColumn fulfillmentId={data.id} />;
  },
};
